module.exports = __webpack_public_path__ + "img/date.aaf28afd.svg";